<h1 mat-dialog-title>{{ 'addressremovedialog.title' | transloco }}</h1>
<div mat-dialog-content>
  <p>{{ 'addressremovedialog.article1' | transloco }} <b>{{address.name}}</b> {{ 'addressremovedialog.article2' | transloco }}</p>
</div>
<div mat-dialog-actions class="actions">
  <button mat-button (click)="doAction()">{{ 'addressremovedialog.delete' | transloco }}</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{ 'addressremovedialog.cancel' | transloco }}</button>
</div>
